import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { ScrubberDataService } from 'src/app/services/scrubber-data.service';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-statute-manager',
  templateUrl: './statute-manager.component.html',
  styleUrls: ['./statute-manager.component.less']
})
export class StatuteManagerComponent implements OnInit{
  @ViewChild('appData', {}) ngForm: NgForm;
  _currentState : string;
  @Output() stateSelected : EventEmitter<string> = new EventEmitter();
  offset : number = 0;
  fetch : number = 50;
  ngOnInit(): void {
    this.scrubs.getStateList();
  }

  constructor(private scrubs : ScrubberDataService, public auth : AuthService){}

  stateChange()
  {
    // console.log(this._currentState);
    // this.scrubs.loadCharges(this._currentState); this one just eats up chrome memory so we def need to filter it down... somehow.
    this.scrubs.loadStatuteBreakout(this._currentState,this.offset,this.fetch);
    this.stateSelected.emit(this._currentState);
  }

}
